const resultPageData = {
    ENFP: {
        name: "冒險小向日",
        description:
            "你是陽光熱情的萝想冒險家，總能點燃團隊氣氛，啟動每一段新旅程！",
        backgroundImage: "/images/background-3.png",
        textColor: "#316926",
        image: "ENFP.png",
        imageWidth: 271,
        imageHeight: 407,
    },
    ENTP: {
        name: "靈感仙人掌",
        description: "你是靈光乍現、總是充滿奇思妙想的小策士！",
        backgroundImage: "/images/background-1.png",
        textColor: "#2B7621",
        image: "ENTP.png",
        imageWidth: 252,
        imageHeight: 378,
    },
    ESFP: {
        name: "繽紛金盞花",
        description: "你是熱情洋溢、讓每個角落充滿歡笑的小太陽！",
        backgroundImage: "/images/background-2.png",
        textColor: "#367623",
        image: "ESFP.png",
        imageWidth: 316,
        imageHeight: 377,
    },
    ESTP: {
        name: "活力榕小子",
        description: "你是快速出擊、隨時準備冒險的行動派夥伴！",
        backgroundImage: "/images/background-3.png",
        textColor: "#217240",
        image: "ESTP.png",
        imageWidth: 273,
        imageHeight: 409,
    },
    INFP: {
        name: "柔光薰衣草",
        description: "你是用溫柔你是守護夢想的心靈園丁！",
        backgroundImage: "/images/background-1.png",
        textColor: "#1D682D",
        image: "INFP.png",
        imageWidth: 316,
        imageHeight: 316,
    },
    INFJ: {
        name: "智慧樹梢",
        description: "你是靜靜觀察世界，默默守護夥伴的智者！",
        backgroundImage: "/images/background-2.png",
        textColor: "#30711C",
        image: "INFJ.png",
        imageWidth: 342,
        imageHeight: 342,
    },
    ISFP: {
        name: "慢活尤加利",
        description: "你是隨性自在、讓人感到安心的療癒小森林！",
        backgroundImage: "/images/background-3.png",
        textColor: "#236623",
        image: "ISFP.png",
        imageWidth: 324,
        imageHeight: 324,
    },
    ISTP: {
        name: "靜穩仙人掌",
        description: "你是低調踏實、用行動證明一切的實幹家！",
        backgroundImage: "/images/background-1.png",
        textColor: "#2E7B33",
        image: "ISTP.png",
        imageWidth: 349,
        imageHeight: 349,
    },
    ENFJ: {
        name: "暖心向日森",
        description: "你是用溫暖照亮別人的靈魂指引者！",
        backgroundImage: "/images/background-2.png",
        textColor: "#14723E",
        image: "ENFJ.png",
        imageWidth: 295,
        imageHeight: 349,
    },
    ENTJ: {
        name: "引航月桂王",
        description: "你是擁有遠見，總能引領大家前行的領航者！",
        backgroundImage: "/images/background-3.png",
        textColor: "#15622C",
        image: "ENTJ.png",
        imageWidth: 285,
        imageHeight: 356,
    },
    ESFJ: {
        name: "守護紫羅蘭",
        description: "你擅長用溫柔細心照料身邊每一個重要的人！",
        backgroundImage: "/images/background-1.png",
        textColor: "#27613F",
        image: "ESFJ.png",
        imageWidth: 269,
        imageHeight: 405,
    },
    ESTJ: {
        name: "穩健橡樹長",
        description: "你堅定可靠、是團隊最堅實的依靠！",
        backgroundImage: "/images/background-2.png",
        textColor: "#276B53",
        image: "ESTJ.png",
        imageWidth: 302,
        imageHeight: 377,
    },
    INTP: {
        name: "思辨錦帶草",
        description: "你是愛探索世界、思考無限可能的思想家！",
        backgroundImage: "/images/background-3.png",
        textColor: "#21693F",
        image: "INTP.png",
        imageWidth: 243,
        imageHeight: 365,
    },
    INTJ: {
        name: "策略黑松藤",
        description: "你是安靜鋒利、默默規劃未來的強大後盾！",
        backgroundImage: "/images/background-1.png",
        textColor: "#346E36",
        image: "INTJ.png",
        imageWidth: 258,
        imageHeight: 376,
    },
    ISFJ: {
        name: "守望榆樹",
        description: "你總是低調穩定、默默守護家人與朋友！",
        backgroundImage: "/images/background-2.png",
        textColor: "#356629",
        image: "ISFJ.png",
        imageWidth: 274,
        imageHeight: 347,
    },
    ISTJ: {
        name: "謹慎冬青",
        description: "你是堅持原則、一步一腳印累積力量的實踐者！",
        backgroundImage: "/images/background-3.png",
        textColor: "#1C6B2D",
        image: "ISTJ.png",
        imageWidth: 258,
        imageHeight: 352,
    },
};

export default resultPageData;
